export const DELETE_SPOT_SUCCESS = 'DELETE_SPOT_SUCCESS';

export const deleteSpotSuccess = ( id: string ) => ({
    type: DELETE_SPOT_SUCCESS,
    payload: {
        id,
    },
});
